<div id="flightResults" class="flight-search-results__ticket-a flex-column-container">
  @if (flights && flights?.length) {
    <div class="flight-search-results__sort-items-container">
      @if (searchParams.bySchedule && multiCityByScheduleFlightsList.length) {
        <div>
          <app-multi-city-flights-by-schedule
            [multiCityByScheduleFlightsList]="multiCityByScheduleFlightsList"
            [source]="source"
            (removeAndSearchAgain)="removeItems($event)"
            (removeItem)="removeMultiCityFlight($event)"
          ></app-multi-city-flights-by-schedule>
        </div>
      }
      @if (isExchange && flights[0]) {
        <div class="flight-title">
          <h2>
            {{ flights[0].outboundFlights[0].originAirportName }}
            <span i18n="@@flilghtSearchTo">to</span>
            {{
              flights[0].outboundFlights[flights[0].outboundFlights.length - 1]
                .destinationAirportName
            }}
          </h2>
          <div>
            <span i18n="@@OutBoundDate">Outbound Date</span>:
            {{ flights[0].outboundFlights[0].dateTimeDeparting | sabsDate: 8 }}
          </div>
          @if (flights[0].inboundFlights[0]) {
            <div>
              <span i18n="@@InBoundDate">Inbound Date</span>:
              {{ flights[0].inboundFlights[0].dateTimeDeparting | sabsDate: 8 }}
            </div>
          }
        </div>
      }
      @if (combinedFlightsKeys?.length && !isPricingExchange) {
        <p
          class="flight-search-results__sort-items flex-row-container--margin-tb showing-container"
          role="status"
        >
          @if (isDual) {
            <span i18n="@@flightTicketsOutbound">Outbound -&nbsp;</span>
          }
          @if (isDualReturn) {
            <span><span i18n="@@flightLegReturn">Return</span> -&nbsp;</span>
          }
          <span i18n="@@Showing">Showing</span>
          {{ flightOffset }}
          <span i18n="@@flightLoading_to">to</span>
          {{
            combinedFlightsKeys.length > flightBoundary
              ? flightBoundary
              : combinedFlightsKeys.length
          }}
          <span i18n="@@of">of</span>
          {{ combinedFlightsKeys.length }}
          <span i18n="@@flights">flights</span>
        </p>
      }
      @if (searchParams.bySchedule) {
        <div>
          <app-light-toggle-group
            tabindex="-1"
            groupAriaLabel="Flight segment selection"
            i18n-groupAriaLabel="@@flightSegmentSelectionToggleGroupLabel"
          >
            @for (item of search?.multiDestination; track item; let i = $index) {
              <app-light-toggle-btn
                [selected]="searchParams.selectedSegment === i"
                (click)="searchParams.selectedSegment = i; seachFlightsBySchedule()"
                tabindex="-1"
              >
                @if (search?.chosenSearchType === FlightSearchType.return) {
                  @if (i === 0) {
                    <span>
                      <span i18n="@@returnOutbound">Outbound</span>
                    </span>
                  }
                  @if (i === 1) {
                    <span>
                      <span i18n="@@returnInbound">Inbound</span>
                    </span>
                  }
                }
                @if (search?.chosenSearchType === FlightSearchType.multiCity) {
                  <span i18n="@@muliCityFlight">Flight</span>: {{ i + 1 }}
                }
              </app-light-toggle-btn>
            }
          </app-light-toggle-group>
        </div>
      }
    </div>
  } @else {
    <app-no-results></app-no-results>
  }
  @if (searchParams.bySchedule && multiCityByScheduleCombinedFlightsList) {
    <div>
      @if (currentFlightSlice?.length) {
        <ul class="available-flights-list" aria-label="Available flights">
          @for (flightKey of currentFlightSlice; track flightKey; let i = $index) {
            <li class="flex-column-container">
              <app-flight-display
                [isExchange]="isExchange"
                [isPricingExchange]="isPricingExchange"
                [flightIndex]="i"
                [isDualFlight]="isDual"
                [isDualReturn]="isDualReturn"
                (selectedMultiCityFlight)="selectedMultiCityFlight($event)"
                (deselectMultiCityFlight)="
                  deselectMultiCityFlight(multiCityByScheduleCombinedFlightsList[flightKey])
                "
                [hideExchangePriceSabre]="hideExchangePriceSabre"
                [loadingHideExchangePriceSabre]="loadingHideExchangePriceSabre"
                [deselectItem]="checkAviability(multiCityByScheduleCombinedFlightsList[flightKey])"
                [selectedItemsId]="selectedItemsId"
                [disableItems]="disable()"
                [combinedFlight]="multiCityByScheduleCombinedFlightsList[flightKey]"
                (selectExchangeFlight)="selectExchangeFlight.emit($event)"
              >
              </app-flight-display>
            </li>
          }
        </ul>
      } @else {
        @if (multiCityByScheduleFlightsList.length > 0) {
          <div class="incompatible-flights-message">
            <p i18n="@@incompatibleFlightsMessage">
              The current itinerary includes flights that cannot be combined. To continue, please
              select a different flight or perform a new search.
            </p>
          </div>
        } @else {
          <app-no-results></app-no-results>
        }
      }
    </div>
  }
  @if (!searchParams.bySchedule && combinedFlights) {
    <div>
      @if (currentFlightSlice?.length) {
        <ul class="available-flights-list" aria-label="Available flights">
          @for (flightKey of currentFlightSlice; track flightKey; let i = $index) {
            <li class="flex-column-container">
              <app-flight-display
                [isExchange]="isExchange"
                [isPricingExchange]="isPricingExchange"
                [hideExchangePriceSabre]="hideExchangePriceSabre"
                [loadingHideExchangePriceSabre]="loadingHideExchangePriceSabre"
                [flightIndex]="i"
                [isDualFlight]="isDual"
                [isDualReturn]="isDualReturn"
                [combinedFlight]="sortCombinedFlights(combinedFlights[flightKey])"
                (selectExchangeFlight)="selectExchangeFlight.emit($event)"
              >
              </app-flight-display>
            </li>
          }
        </ul>
      } @else {
        <app-no-results></app-no-results>
      }
    </div>
  }
  @if (flights && combinedFlightsKeys.length > 1) {
    <ngb-pagination
      class="flex-row-container pageination"
      [collectionSize]="combinedFlightsKeys.length"
      [(page)]="currentPage"
      [pageSize]="pageSize"
      [maxSize]="deviceDetector.isMobile ? 2 : 4"
      (pageChange)="changePage($event)"
    >
      <ng-template ngbPaginationNumber let-page
        ><span class="visuallyhidden">Page&nbsp;</span>{{ page }}</ng-template
      >
    </ngb-pagination>
  }
</div>
